<template>
    <div
        class="uik-data"
        :class="[
            `uik-data--${size}`,
            `uik-data--${layout}`
        ]"
    >
        <div v-if="layout === 'vertical'" class="uik-data__vertical">
            <div v-if="title" class="uik-data__title">{{ title }}</div>
            <div v-if="content" class="uik-data__content-wrapper">
                <div class="uik-data__content">{{ content }}</div>
                <UikTrend
                    v-if="trend"
                    :content="trend"
                    :type="trendType"
                    :direction="trendDirection"
                />
            </div>
            <div v-if="subtitle" class="uik-data__subtitle">{{ subtitle }}</div>
        </div>

        <div v-if="layout === 'horizontal'" class="uik-data__horizontal">
            <div class="uik-data__title-container">
                <div v-if="title" class="uik-data__title">{{ title }}</div>
                <div v-if="subtitle" class="uik-data__subtitle">{{ subtitle }}</div>
            </div>
            <div v-if="content" class="uik-data__content-wrapper">
                <div class="uik-data__content">{{ content }}</div>
                <UikTrend
                    v-if="trend"
                    :content="trend"
                    :type="trendType"
                    :direction="trendDirection"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikData",
    props: {
        /**
         * Text above data
         */
        title: {
            type: String,
            default: ""
        },
        /**
         * Displayed data
         */
        content: {
            type: String,
            default: ""
        },
        /**
         * Text below data
         */
        subtitle: {
            type: String,
            default: ""
        },
        /**
         * Size of texts
         */
        size: {
            type: String,
            default: "regular",
            validator (value) {
                return [
                    "regular",
                    "big",
                    "small"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Text layout
         */
        layout: {
            type: String,
            default: "vertical",
            validator (value) {
                return [
                    "vertical",
                    "horizontal"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Trend value (not displayed if there's no value)
         */
        trend: {
            type: String,
            default: ""
        },
        /**
         * Trend type - defines color
         */
        trendType: {
            type: String,
            default: "good",
            validator (value) {
                return [
                    "good",
                    "bad"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Direction the trend arrow is pointing at
         */
        trendDirection: {
            type: String,
            default: "up",
            validator (value) {
                return [
                    "up",
                    "down"
                ].indexOf(value) !== -1
            }
        }
    }
}
</script>

<style lang="scss">
.uik-data {
  &--horizontal {
    width: 100%;
    flex-grow: 1;
  }

  .uik-data__vertical {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .uik-data__horizontal {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;

    .uik-data__title-container {
      flex-grow: 1;
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: flex-start;

      & + .uik-data__content-wrapper {
        margin-left: 20px;
      }
    }
  }

  .uik-data__title {
    color: $textBase;
  }

  .uik-data__content-wrapper {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-end;

    .uik-data__content {
      color: $textMain;
    }

    .uik-trend {
      margin-left: 6px;
    }
  }

  .uik-data__subtitle {
    color: $textSecondary;
    font-weight: 400;
  }

  &--regular {
    .uik-data__title {
      font-size: 15px;
      line-height: 17px;
      font-weight: 400;

      & + .uik-data__content-wrapper {
        margin-top: 6px;
      }

      & + .uik-data__subtitle {
        margin-top: 3px;
      }
    }
    .uik-data__content-wrapper {
      .uik-data__content {
        font-size: 21px;
        line-height: 24px;
        font-weight: 600;
      }

      .uik-trend {
        margin-bottom: 3px;
      }

      & + .uik-data__subtitle {
        margin-top: 5px;
      }
    }

    .uik-data__subtitle {
      font-size: 12px;
      line-height: 14px;
    }
  }
  &--small {
    .uik-data__title {
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;

      & + .uik-data__content-wrapper {
        margin-top: 2px;
      }

      & + .uik-data__subtitle {
        margin-top: 2px;
      }
    }
    .uik-data__content-wrapper {
      .uik-data__content {
        font-size: 19px;
        line-height: 22px;
        font-weight: 600;
      }

      .uik-trend {
        margin-bottom: 3px;
      }

      & + .uik-data__subtitle {
        margin-top: 3px;
      }
    }

    .uik-data__subtitle {
      font-size: 10.5px;
      line-height: 12px;
    }
  }

  &--big {
    .uik-data__title {
      font-size: 15px;
      line-height: 17px;

      & + .uik-data__content-wrapper {
        margin-top: 6px;
      }

      & + .uik-data__subtitle {
        margin-top: 3px;
      }
    }

    .uik-data__content-wrapper {
      .uik-data__content {
        font-size: 32px;
        line-height: 37px;
        font-weight: 500;
      }

      .uik-trend {
        margin-bottom: 5px;
      }

      & + .uik-data__subtitle {
        margin-top: 6px;
      }
    }

    .uik-data__subtitle {
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>
